import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  link: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'left',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '22px',
  },
  linkDisabled: {
    color: '#757575',
    cursor: 'default',
    textDecoration: 'none',
    textAlign: 'left',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '22px',
  },
  timeRed: {
    color: '#E74C3C',
  },
  resendSuccessText: {
    color: '#37BB7C',
    textAlign: 'left',
    fontSize: 16,
    marginTop: 14,
  },
}));

const ResendCodeLink = ({
  isDisabled,
  isLocked,
  countdownSeconds,
  resendText,
  resendTextWithTime,
  showSuccess,
  successText,
  onResend,
}) => {
  const classes = useStyles();

  const getCountdownText = () => {
    if (!isDisabled) return resendText;

    if (countdownSeconds > 0) {
      const parts = resendTextWithTime.split('#time');
      if (parts.length !== 2) {
        return resendTextWithTime.replace('#time', countdownSeconds);
      }

      return (
        <>
          {parts[0]}
          <span className={classes.timeRed}>{countdownSeconds} seconds</span>
          {parts[1].replace(' seconds', '')}
        </>
      );
    }

    return resendText;
  };

  return (
    <Box textAlign="left" mt="14px">
      <Typography
        className={isDisabled || isLocked ? classes.linkDisabled : classes.link}
        onClick={isDisabled || isLocked ? undefined : onResend}
      >
        {getCountdownText()}
      </Typography>

      {showSuccess && (
        <Typography className={classes.resendSuccessText}>
          {successText}
        </Typography>
      )}
    </Box>
  );
};

ResendCodeLink.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool.isRequired,
  countdownSeconds: PropTypes.number.isRequired,
  resendText: PropTypes.string.isRequired,
  resendTextWithTime: PropTypes.string.isRequired,
  showSuccess: PropTypes.bool.isRequired,
  successText: PropTypes.string.isRequired,
  onResend: PropTypes.func.isRequired,
};

export default ResendCodeLink;
